var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-list',{attrs:{"title":"Страны и города","breadcrumbs":_vm.breadcrumbs,"data-source":_vm.dataSource},scopedSlots:_vm._u([{key:"caption",fn:function(data){return [_c('router-link',{attrs:{"to":`/manage/regions/${data.item.id}`}},[_vm._v(" "+_vm._s(data.item.caption)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }